import {Injectable} from '@angular/core';
import {UserCompanyList, UserQuery, UserRequest} from '../repository/entity/user.entity';
import {UserRepository} from '../repository/user.repository';
import {HttpErrorResponse} from '@angular/common/http';
import {BehaviorSubject, catchError, Observable, of, tap} from 'rxjs';
import {ApiResponseError} from '../../base/repository/entity/base.entity';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private _userRepo: UserRepository,
    private toastService: ToastrService,
    private spinner: NgxSpinnerService
  ) {
  }

  private _listUserCompany$ = new BehaviorSubject<UserCompanyList[]>([]);
  public get listUserCompany$(): Observable<UserCompanyList[]> {
    return this._listUserCompany$;
  }

  public set listUserCompany$(value: UserCompanyList[]) {
    this._listUserCompany$.next(value);
  }

  fetchListUserCompany() {
    return this._userRepo.getUserCompany().pipe(
      tap((value) => (this.listUserCompany$ = value.result)),
      catchError(this.handleConfigurationError.bind(this))
    );
  }

  fetchListUser(query: UserQuery) {
    return this._userRepo.getUser(query).pipe(
      catchError(this.handleConfigurationError.bind(this))
    );
  }

  fetchUserByUsername(username: string) {
    return this._userRepo.getUserByUsername(username).pipe(
      catchError(this.handleConfigurationError.bind(this))
    );
  }

  createUser(request: UserRequest) {
    return this._userRepo.createUser(request).pipe(
      catchError(this.handleConfigurationError.bind(this))
    );
  }

  updateUser(request: UserRequest) {
    return this._userRepo.updateUser(request).pipe(
      catchError(this.handleConfigurationError.bind(this))
    );
  }

  deleteUser(username: string) {
    return this._userRepo.deleteUser(username).pipe(
      catchError(this.handleConfigurationError.bind(this))
    );
  }

  restoreUser(username: string) {
    return this._userRepo.restoreUser(username).pipe(
      catchError(this.handleConfigurationError.bind(this))
    );
  }

  private handleConfigurationError(err: HttpErrorResponse): Observable<null> {
    const errors: ApiResponseError[] = err?.error?.errors;
    if (errors && errors.length > 0) {
      const errorMessages: string[] = errors.map((error) => error.message);
      this.toastService.error(errorMessages.join(', '));
    }
    this.spinner.hide();
    return of(null);
  }
}
